import { trpc } from '@/lib/trpc';
import type { SubsMonthlyFilters, AIToolsFilters, TransactionFilters } from '../../../shared/types';

export function useExecutiveSummary() {
  return trpc.subscriptions.getExecutiveSummary.useQuery(undefined, {
    staleTime: 5 * 60 * 1000,
  });
}

export function useSubscriptionsMonthly(filters: SubsMonthlyFilters = {}) {
  return trpc.subscriptions.getSubscriptionsMonthly.useQuery(filters, {
    staleTime: 5 * 60 * 1000,
  });
}

export function useAIToolsMonthly(filters: AIToolsFilters = {}) {
  return trpc.subscriptions.getAIToolsMonthly.useQuery(filters, {
    staleTime: 5 * 60 * 1000,
  });
}

export function useTransactions(filters: TransactionFilters = {}) {
  return trpc.subscriptions.getTransactions.useQuery(filters, {
    staleTime: 2 * 60 * 1000,
  });
}

export function useVendorRanking(month?: string) {
  return trpc.subscriptions.getVendorRanking.useQuery({ month }, {
    staleTime: 5 * 60 * 1000,
  });
}

export function useAreaBreakdown(filters: { dateFrom?: string; dateTo?: string; isAITool?: boolean; department?: string; vendor?: string } = {}) {
  return trpc.subscriptions.getAreaBreakdown.useQuery(filters, {
    staleTime: 5 * 60 * 1000,
  });
}

export function useIndirectCostRealAreas(filters: { dateFrom?: string; dateTo?: string } = {}) {
  return trpc.subscriptions.getIndirectCostRealAreas.useQuery(filters, {
    staleTime: 5 * 60 * 1000,
  });
}
